"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _animationUtils = require("./animationUtils");
Object.keys(_animationUtils).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _animationUtils[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _animationUtils[key];
    }
  });
});
var _applyAnimations = require("./applyAnimations");
Object.keys(_applyAnimations).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _applyAnimations[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _applyAnimations[key];
    }
  });
});